import React from 'react';
import { MappedLeaveItem } from '../../shared/types';
import { TextField } from 'framework/ui/field';

const NumberOfCalendarDaysField = ({ value }: { value?: MappedLeaveItem }) => {
  const showTaken =
    value?.takenFromPeriod && value?.takenFromPeriod !== value?.period?.duration ? `${value.takenFromPeriod}d` : null;
  return (
    <TextField
      value={`${value?.duration ?? value?.period?.duration ?? 0}d${showTaken ? ` (${showTaken} from current period)` : ''}`}
    />
  );
};

export default NumberOfCalendarDaysField;
